import React, { useEffect } from 'react';
import { ArrowRight, FileCheck } from 'lucide-react';
import Spline from '@splinetool/react-spline';

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-headline">
              Hypotheken-Dossier automatisiert.<br />
              Von <span className="highlight-time">45 Minuten</span> auf <span className="highlight-time">2 Minuten</span>.
            </h1>
            
            <p className="hero-subheadline">
              PDFs hochladen. Daten automatisch extrahieren.<br />
              Strukturiertes Word-Dokument in Minuten erhalten.<br />
              <span className="hero-emphasis">Weniger Copy-Paste. Mehr Abschlüsse.</span>
            </p>
            
            <p className="hero-additional-note">
              Wir sind auch offen, andere Dokumentenautomatisierungen zu besprechen und massgeschneiderte Lösungen für Ihre spezifischen Bedürfnisse zu entwickeln.
            </p>
            
            <div className="hero-cta-group">
              <a 
                href="https://cal.eu/doctimize/kostenlose-bedarfsabklarung-doctimize"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary hero-cta"
              >
                Kostenloses Erstgespräch vereinbaren
                <ArrowRight size={20} />
              </a>
              
              <button 
                className="btn-secondary hero-cta-secondary"
                onClick={scrollToContact}
              >
                Dokumenten-Automatisierung besprechen
                <FileCheck size={20} />
              </button>
            </div>
          </div>
        </div>

        {/* Right - Spline 3D */}
        <div className="hero-spline-container">
          <Spline 
            scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
            className="hero-spline"
          />
        </div>
      </div>
      
      {/* Animated background grid */}
      <div className="hero-grid-overlay"></div>
    </section>
  );
};

export default Hero;
